module.exports = __webpack_public_path__ + "e6cd58e5b45922c0944d2ead0c59ef27.MP3";